"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _get = _interopRequireDefault(require("lodash/get"));
var _resetPasswordForm = _interopRequireWildcard(require("../stores/forms/reset-password-form"));
var _posthogUtils = require("../utils/posthog-utils");
var _posthogEvents = require("../posthog-events");
var _constants = require("../constants");
var _phone = _interopRequireDefault(require("phone"));
var _enums = require("../enums");
var _lodash = require("lodash");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20; //helpers
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ResetPasswordPage = (_class = /*#__PURE__*/function () {
  function ResetPasswordPage() {
    var _this = this;
    _classCallCheck(this, ResetPasswordPage);
    _initializerDefineProperty(this, "isRequestedReset", _descriptor, this);
    _initializerDefineProperty(this, "isInvalidLink", _descriptor2, this);
    _initializerDefineProperty(this, "emailIsNotSent", _descriptor3, this);
    _initializerDefineProperty(this, "loading", _descriptor4, this);
    _initializerDefineProperty(this, "passwordsMatch", _descriptor5, this);
    _initializerDefineProperty(this, "isValidNewPassword", _descriptor6, this);
    _initializerDefineProperty(this, "isInputFocused", _descriptor7, this);
    _defineProperty(this, "form", _resetPasswordForm["default"]);
    _defineProperty(this, "translations", {});
    _initializerDefineProperty(this, "setRequestReset", _descriptor8, this);
    _initializerDefineProperty(this, "setNotSendEmail", _descriptor9, this);
    _initializerDefineProperty(this, "setLoading", _descriptor10, this);
    _initializerDefineProperty(this, "setIsInputFocused", _descriptor11, this);
    _initializerDefineProperty(this, "validateEmail", _descriptor12, this);
    _initializerDefineProperty(this, "validatePhoneNumber", _descriptor13, this);
    _initializerDefineProperty(this, "validatePassword", _descriptor14, this);
    _initializerDefineProperty(this, "submitForgotPasswordForm", _descriptor15, this);
    _initializerDefineProperty(this, "submitResetPasswordForm", _descriptor16, this);
    _initializerDefineProperty(this, "resetPasswordLinkNotValid", _descriptor17, this);
    _initializerDefineProperty(this, "handleForgotPasswordError", _descriptor18, this);
    _initializerDefineProperty(this, "handleResetPasswordError", _descriptor19, this);
    _initializerDefineProperty(this, "reset", _descriptor20, this);
    _defineProperty(this, "setStore", function (store) {
      _this.store = store;
    });
    _defineProperty(this, "setNotification", function (notification) {
      _this.notification = notification;
    });
    (0, _mobx.makeObservable)(this);
  }
  return _createClass(ResetPasswordPage, [{
    key: "setTranslations",
    value: function setTranslations(translations) {
      this.translations = translations;
      this.form = (0, _resetPasswordForm.createLocalisedForm)(translations);
    }
  }, {
    key: "isPasswordValid",
    value: function isPasswordValid(password) {
      var hasMinCharacters = password.length >= 8;
      var hasLowercaseChar = /[a-z]/.test(password);
      var hasUppercaseChar = /[A-Z]/.test(password);
      var containsNumber = /\d/.test(password);
      var containsNonAlphaChar = /[^a-zA-Z0-9\s:]/.test(password);
      var isPasswordValid = hasMinCharacters && hasLowercaseChar && hasUppercaseChar && containsNumber && containsNonAlphaChar;
      if (isPasswordValid) {
        return true;
      } else {
        this.passwordsMatch = true;
        return false;
      }
    }
  }]);
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isRequestedReset", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isInvalidLink", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "emailIsNotSent", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "passwordsMatch", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isValidNewPassword", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isInputFocused", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "setRequestReset", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (val) {
      return _this2.isRequestedReset = val;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "setNotSendEmail", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (val) {
      return _this3.emailIsNotSent = val;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "setLoading", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (val) {
      return _this4.loading = val;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "setIsInputFocused", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (isInputFocused) {
      _this5.isInputFocused = isInputFocused;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "validateEmail", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (forgotPasswordMutation) {
      var _this6$form$values = _this6.form.values(),
        email = _this6$form$values.email;
      if (_constants.emailValidationRegex.test(email)) {
        _this6.submitForgotPasswordForm(forgotPasswordMutation);
      }
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "validatePhoneNumber", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function (forgotPasswordMutation) {
      var _this7$form$values = _this7.form.values(),
        phoneNumber = _this7$form$values.phoneNumber;
      var parsedPhoneNumber = (0, _phone["default"])(phoneNumber);
      if (parsedPhoneNumber.isValid) {
        _this7.submitForgotPasswordForm(forgotPasswordMutation, true);
      }
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "validatePassword", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function (resetPasswordMutation, router, store, views) {
      var _this8$form$values = _this8.form.values(),
        newPassword = _this8$form$values.newPassword,
        newPasswordConfirm = _this8$form$values.newPasswordConfirm;
      _this8.isValidNewPassword = _this8.isPasswordValid(newPassword);
      if (_this8.isValidNewPassword) {
        _this8.passwordsMatch = newPassword === newPasswordConfirm;
      }
      if (_this8.passwordsMatch && _this8.isValidNewPassword) {
        _this8.submitResetPasswordForm(resetPasswordMutation, router, store, views);
      }
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "submitForgotPasswordForm", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function (forgotPasswordMutation, isPhone) {
      var _this9$form$values = _this9.form.values(),
        email = _this9$form$values.email,
        phoneNumber = _this9$form$values.phoneNumber;
      _this9.setLoading(true);
      forgotPasswordMutation({
        email: email,
        phoneNumber: phoneNumber
      }).then(function (response) {
        if (!(0, _get["default"])(response, 'data.forgotPassword.result')) {
          return Promise.reject();
        }
        if (isPhone) {
          _this9.store.router.goTo(_this9.store.app.views.resetPasswordPhone, undefined, {
            phoneNumber: phoneNumber
          });
        } else {
          _this9.isRequestedReset = true;
          _this9.emailIsNotSent = false;
        }
        _this9.setLoading(false);
      })["catch"](_this9.handleForgotPasswordError);
    };
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "submitResetPasswordForm", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function (resetPasswordMutation, router, store, views) {
      var phoneNumber = _this10.store.router.queryParams.phoneNumber;
      if (phoneNumber) {
        phoneNumber = phoneNumber.replace('%2B', '+');
      }
      var _this10$form$values = _this10.form.values(),
        resetCode = _this10$form$values.resetCode,
        newPassword = _this10$form$values.newPassword;
      var token = router.queryParams.token;
      if (!token) {
        token = resetCode;
      }
      resetPasswordMutation({
        token: token,
        phoneNumber: phoneNumber,
        password: newPassword
      }).then(function (result) {
        var _result$errors;
        if (!result.data.resetPassword) throw new Error((_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors[0].message);
        (0, _posthogUtils.posthogCapture)(_posthogEvents.posthogEvents.resetPasswordSuccessful);
        _this10.notification.success(_this10.translations.passwordReset);
        _this10.form.clear();
        router.goTo(views.signIn, {
          loginType: (0, _lodash.kebabCase)(phoneNumber ? _enums.DOMAIN_LOGIN_OPTIONS.PHONE_NUMBER : _enums.DOMAIN_LOGIN_OPTIONS.EMAIL)
        });
      })["catch"](_this10.handleResetPasswordError);
    };
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "resetPasswordLinkNotValid", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this11 = this;
    return function () {
      _this11.isInvalidLink = true;
    };
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "handleForgotPasswordError", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;
    return function () {
      _this12.notification.error(_this12.translations.canNotSentPasswordResetLink);
      _this12.emailIsNotSent = true;
      _this12.setLoading(false);
    };
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "handleResetPasswordError", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this13 = this;
    return function (error) {
      var errorMessage = _this13.translations.canNotResetPassword;
      if (error.message === 'Invalid reset password pincode') {
        errorMessage = _this13.translations.invalidResetCode;
      }
      _this13.notification.error(errorMessage);
    };
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "reset", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this14 = this;
    return function () {
      _this14.form.clear();
      _this14.setLoading(false);
      _this14.isRequestedReset = false;
      _this14.emailIsNotSent = true;
    };
  }
})), _class);
var _default = exports["default"] = ResetPasswordPage;
//# sourceMappingURL=reset-password-page.js.map